import { album } from './../models/album.model';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { Injectable } from '@angular/core';

@Injectable()

export class AlbumService{
  albums: album[] = [];
  allAlbums: album[] = [];

  constructor(private http: HttpClient, private uService: UserService){
  }

  ngOnInit() {
  }

  getAlbum(id):album
  {
    let retval:album = new album();
    this.allAlbums.forEach(element => {
      if (element.id == id)
      {
        retval = element;
      }
    });

    return retval;
  }

  load(){
    if (this.allAlbums.length == 0)
    {
      this.http.get('https://minmusik.se/api/album?user_id=' + this.uService.user.id).subscribe((data:album[]) => {

        this.allAlbums = data;

      });
    }

    if (this.albums.length == 0)
    {
      this.http.get('https://minmusik.se/api/album?user=true&user_id=' + this.uService.user.id ).subscribe((data:album[]) => {

        this.albums = data;

      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/service/album.service.ts